import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function ProgressRing({
  progress = 0,
  size = 120,
  strokeWidth = 10,
  color = "var(--ds-indigo-500)",
  trackColor = "var(--ds-slate-100)",
  label = "",
  subLabel = "",
  children
}) {
  const [offset, setOffset] = useState(0);
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * circumference;
    setOffset(progressOffset);
  }, [progress, circumference]);

  return (
    <div className="relative flex flex-col items-center justify-center" style={{ width: size, height: size }}>
      <svg className="transform -rotate-90" width={size} height={size}>
        <circle
          className="transition-colors duration-300"
          stroke={trackColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={center}
          cy={center}
        />
        <motion.circle
          stroke={color}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          r={radius}
          cx={center}
          cy={center}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        {children || (
          <>
            <span className="text-2xl font-black text-slate-900 dark:text-white ds-gradient-text bg-gradient-to-br from-indigo-600 to-violet-600">
              {progress}%
            </span>
            {label && <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mt-1">{label}</span>}
            {subLabel && <span className="text-[9px] font-medium text-slate-500">{subLabel}</span>}
          </>
        )}
      </div>
    </div>
  );
}
